// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Topic_wrapper__91Zll","content":"Topic_content__b6KEr"};